import React from "react";
import { Popover, makeStyles } from "@material-ui/core";
import { TwitterPicker } from "react-color";

const useStyles = makeStyles((theme) => ({
  popover: {
    padding: theme.spacing(1),
  },
}));

/**
 * ColorPicker Component
 *
 * A popover component for selecting colors
 *
 * @param {Object} props - Component props
 * @param {HTMLElement} props.anchorEl - The element to anchor the popover to
 * @param {Function} props.onClose - Callback for when the popover is closed
 * @param {Function} props.onColorChange - Callback for when a color is selected
 * @returns {JSX.Element} The rendered component
 */
const ColorPicker = ({ anchorEl, onClose, onColorChange }) => {
  const classes = useStyles();
  const open = Boolean(anchorEl);

  // Common colors for resumes
  const colors = [
    "#000000", // Black
    "#333333", // Dark Gray
    "#666666", // Medium Gray
    "#999999", // Light Gray
    "#0000FF", // Blue
    "#000080", // Navy Blue
    "#008000", // Green
    "#800000", // Maroon
    "#8B0000", // Dark Red
    "#4B0082", // Indigo
    "#2F4F4F", // Dark Slate Gray
    "#696969", // Dim Gray
    "#708090", // Slate Gray
    "#778899", // Light Slate Gray
    "#808080", // Gray
    "#A9A9A9", // Dark Gray
  ];

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      className={classes.popover}
    >
      <TwitterPicker
        colors={colors}
        onChangeComplete={onColorChange}
        triangle="hide"
      />
    </Popover>
  );
};

export default ColorPicker;
